import { render, staticRenderFns } from "./_FactFindMain.vue?vue&type=template&id=83e5046c&"
import script from "./_FactFindMain.vue?vue&type=script&lang=ts&"
export * from "./_FactFindMain.vue?vue&type=script&lang=ts&"
import style0 from "./_FactFindMain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports